import { RootState } from '../index';
import { IProfile } from 'types';

export function profileSelector(state: RootState): IProfile | null | undefined {
  return state.account.profile;
}
